import React from 'react';

const ResponsiveTableRow = props => (
  <ul className={`row ${props.className ? props.className : ''}`}>
    {props.children.map((elem, i) => {
      return (
        <elem.type
          {...elem.props}
          headers={props.headers}
          index={i}
          key={`table-row${i}`}
        />
      );
    })}
  </ul>
);

export default ResponsiveTableRow;



// WEBPACK FOOTER //
// ./app/javascript/common/components/responsive-table-row.js